module.exports = __webpack_public_path__ + "img/LTS_SB.5c03d585.gif";